import type { SVGProps } from "react";

/**
 * call-cancel-filled, phone, hangup
 * @category Communication
 */
export default function IconCallCancelFilled(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M10.8242 12.1151C10.4161 11.654 10.0422 11.1618 9.70649 10.6427C9.46639 10.2715 9.52689 9.73471 9.91892 9.35836C10.644 8.66231 10.921 7.62038 10.6374 6.65615L10.1427 4.97404C9.79845 3.80369 8.72434 3 7.50442 3H5.72284C4.24801 3 2.92738 4.20552 3.09672 5.79624C3.34796 8.15623 4.09035 10.4576 5.28656 12.5194C5.90448 13.5844 6.63466 14.5761 7.46096 15.4784L3.21967 19.7197C2.92678 20.0126 2.92678 20.4874 3.21967 20.7803C3.51256 21.0732 3.98744 21.0732 4.28033 20.7803L20.7803 4.28033C21.0732 3.98744 21.0732 3.51256 20.7803 3.21967C20.4874 2.92678 20.0126 2.92678 19.7197 3.21967L10.8242 12.1151Z'
        fill='currentColor'
      />
      <path
        d='M11.4815 18.7143C10.8526 18.3494 10.2492 17.9454 9.6748 17.5056L13.0748 14.1055C13.1683 14.1698 13.2628 14.2327 13.3582 14.2944C13.7294 14.5345 14.2662 14.474 14.6425 14.082C15.3386 13.3569 16.3805 13.0799 17.3448 13.3635L19.0269 13.8582C20.1972 14.2024 21.0009 15.2766 21.0009 16.4965V18.25C21.0009 19.743 19.7705 21.0633 18.1723 20.8864C15.8298 20.627 13.5573 19.9187 11.4815 18.7143Z'
        fill='currentColor'
      />
    </svg>
  );
}
